import { tv } from 'tailwind-variants';

export const arrowClasses = tv({
  base: 'w-10 h-10 rounded-full flex items-center justify-center transition-opacity bg-skin-primary',
  variants: {
    isDisabled: {
      true: 'bg-skin-disabled text-navLink-selected cursor-not-allowed',
    },
  },
});
